__turbopack_context__.v({
  "column": "DeluxeModal-module__1pAzHq__column",
  "grid": "DeluxeModal-module__1pAzHq__grid",
  "image": "DeluxeModal-module__1pAzHq__image",
  "imageContainer": "DeluxeModal-module__1pAzHq__imageContainer",
  "price": "DeluxeModal-module__1pAzHq__price",
  "text": "DeluxeModal-module__1pAzHq__text",
});
